<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Mensagens — Comunicado interno
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  enviar um comunicado
        |  para cada usuário interno da prefeitura.

      .toast.toast-primary
        | A caixa fica no menu
        strong  Mensagens
        | , para o usuário autenticado. O comunicado não escolhe um destinatário: a mensagem é gerada para cada usuário interno.

      h5.h5 1. Abrir o comunicado
      ol
        li No menu lateral, clique em
          strong  Mensagens
          | .
        li Na caixa, clique em
          strong  Novo comunicado interno
          | .

      h5.h5 2. Preencher e enviar
      figure.manual-figure
        img(:src="imgForm" alt="Formulário de comunicado interno")
      ol
        li Leia o aviso:
          strong  Este comunicado vai enviar uma mensagem para cada usuário interno da prefeitura
          | .
        li O título já começa com o prefixo
          strong  Comunicado interno:
          | . Complete o restante em
          strong  Título
          | .
        li Escolha a
          strong  Prioridade
          | :
          strong  Baixa
          | ,
          strong  Média
          | ,
          strong  Alta
          |  ou
          strong  Máxima
          | . O padrão é
          strong  Média
          | .
        li Escreva o
          strong  Conteúdo
          | , com pelo menos 10 caracteres.
        li Se precisar de arquivos, clique em
          strong  Anexos
          | , inclua os arquivos e confirme. A miniatura aparece acima do botão; a lixeira remove o anexo.
        li Clique em
          strong  Enviar
          | . A confirmação é
          strong  Comunicado enviado com sucesso
          |  e a tela volta para a lista anterior.
      p Cada destinatário vê o comunicado na própria caixa de
        strong  Mensagens recebidas
        | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgForm: require("@/assets/manuais/49-mensagens-comunicado.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
